<template>
  <div
    :class="{
      'list-or-desc': true,
      centered,
    }"
    ref="listOrDesc"
    v-tooltip="{
      content: 'Drag and drop images to place them in the crossword',
      show: showTooltip && !artworkvisible,
      placement: 'top-start',
      trigger: 'manual',
      classes: ['tooltip images-tooltip', 'ph3 pv2 mb2 mt0 pt4 pr2 f6'],
    }"
  >
    <div>
      <div
        v-if="!completed"
        class="list-container"
        ref="listContainer"
        @touchstart="touchstart"
        @touchmove="touchmove"
        @touchend="touchend"
      >
        <drop v-if="images.length" @drop="handleDrop" class="drop-area">
          <div class="list" ref="slider">
            <div class="mr3" v-for="(image, index) in images" :key="index">
              <drag
                @dragstart="dragstart"
                @dragend="dragend"
                :transfer-data="{
                  from: 'list',
                  img: image.url,
                  thumbUrl: image.thumbUrl,
                }"
              >
                <img
                  :alt="`${image.author} - ${image.description} ${image.date}`"
                  :class="{
                    br2: true,
                    asset: true,
                    disabled: image.disabled,
                  }"
                  :width="imagesSize"
                  :height="imagesSize"
                  :src="image.thumbUrl"
                  @click="onImageClick(image)"
                />
              </drag>
            </div>
          </div>
        </drop>
        <div v-else class="fixGrid">
          <Fix />
        </div>
      </div>
      <div v-else class="congrats flex flex-column">
        <Congrats />
        <div class="flex flex-column tl ml3">
          <p class="congrats-sentence">
            You made it to the end of this crossword.
          </p>

          <p class="congrats-sentence" v-if="getLevelDisplay() < getMaxLevel">
            <button @click="nextLevel">Try next level</button>
          </p>
          <p class="congrats-sentence" v-else>
            You've finished all the crosswords! Congratulations!
          </p>
        </div>
      </div>
    </div>
    <div>
      <div class="iconBack" @click="moveBackward" ref="arrowBack">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 0 24 24"
          width="24"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
          />
        </svg>
      </div>
      <div class="iconForward" @click="moveForward" ref="arrowForward">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 0 24 24"
          width="24"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import Fix from "./Fix";
import Congrats from "./Congrats";

function getComputedTranslateXY(obj) {
  const transArr = [];
  if (!window.getComputedStyle) return;
  const style = getComputedStyle(obj),
    transform = style.transform || style.webkitTransform || style.mozTransform;
  let mat = transform.match(/^matrix3d\((.+)\)$/);
  if (mat) return parseFloat(mat[1].split(", ")[13]);
  mat = transform.match(/^matrix\((.+)\)$/);
  mat ? transArr.push(parseFloat(mat[1].split(", ")[4])) : transArr.push(0);
  mat ? transArr.push(parseFloat(mat[1].split(", ")[5])) : transArr.push(0);
  return transArr;
}

export default {
  inject: ["getMaxLevel", "getLevelDisplay"],
  data: function() {
    //console.log(this.grid);
    const completed = this.grid.cells.every((c) => c.isValid);
    return {
      isDown: false,
      itemDown: null,
      scrollLeft: null,
      draggable: false,
      checkMoves: false,

      current: null,
      completed,
      height: null,

      startX: 0,
      startY: 0,
      deltaX: 0,
      deltaY: 0,
      isDragging: false,
      centered: false,
    };
  },
  mounted: function() {
    if (this.$el.querySelector(".list")) {
      this.centered =
        this.$el.querySelector(".list").getBoundingClientRect().width <
        window.innerWidth;

      this.maxDeltaX =
        this.$el.querySelector(".list").getBoundingClientRect().width -
        window.innerWidth;

      this.$refs.arrowBack.style.display = "none";
      this.$refs.arrowForward.style.display = "none";
      this.showHideArrows();
    }

    this.height = this.$refs.listOrDesc.getBoundingClientRect().height;
    this.$root.$on("image:reset", (val) => {
      const img = this.images.find((i) => i.url === val);
      this.unplacedImages.unshift(img);
    });

    this.$root.$on("grid:fixed", () => {
      this.startX = 0;
      this.startY = 0;
      this.deltaX = 0;
      this.deltaY = 0;
      delete this.maxDeltaX;
      this.completed = false;
    });

    this.$root.$on("grid:changed", () => {
      setTimeout(() => {
        if (this.$el.querySelector(".list")) {
          //console.log("grid =", this.$el.querySelector(".list"));
          this.maxDeltaX =
            this.$el.querySelector(".list").getBoundingClientRect().width -
            window.innerWidth;
        }
      }, 100);
      this.isDragging = false;
    });

    this.$root.$on("level:changed", () => {
      this.showHideArrows();
    });

    // this.$root.$on("image:hide", () => {
    //   //this.current = null;
    // });

    this.$root.$on("board:completed", () => {
      this.completed = true;
    });

    this.$root.$on("image:placed", () => {
      this.current = null;
    });

    window.onresize = () => {
      setTimeout(() => {
        this.showHideArrows();
      }, 200);
    };

    this.$el.style.opacity = 1;
  },
  props: {
    grid: Object,
    id: String,
    artworkvisible: Boolean,
    showTooltip: Boolean,
  },

  computed: {
    images: function() {
      const usedValues = this.grid.cells.map((c) => c.value).filter(Boolean);
      return this.grid.images.filter((i) => !usedValues.includes(i.url));
    },
    imagesSize: function() {
      return "90px";
    },
  },
  watch: {
    images: function() {
      // center when possible
      setTimeout(() => {
        const imagesSize = 106; // 90 + 16
        this.maxDeltaX = imagesSize * this.images.length - window.innerWidth;
        if (this.images.length) {
          // If we can fit all images, do so and center them
          if (imagesSize * this.images.length < window.innerWidth) {
            this.centered = true;
            this.$refs.listContainer.style.transform = `translateX(0px)`;
          }
          // If we could but can no longer fit all images (after clean grid or replacing manually images in the list)
          else if (this.centered) {
            this.startX = 0;
            this.startY = 0;
            this.deltaX = 0;
            this.deltaY = 0;

            this.completed = false;
            this.centered = false;
            this.$refs.listContainer.style.transform = `translateX(0px)`;
          }
          // If the list is still too long
          else {
            console.log("check transform");
            const lastImage = this.$el.querySelector(".list > div:last-child");
            const { right } = lastImage.getBoundingClientRect();
            const windowWidth = window.innerWidth;
            // If the last image in in the viewport, fix the transform to put it next to the right border
            if (right <= windowWidth) {
              console.log("fix transform");
              this.deltaX += windowWidth - right - 16;
              this.$refs.listContainer.style.transform = `translateX(${this.deltaX}px)`;
            }
          }
        }
      }, 1);
    },
    isDragging: function(val) {
      if (val) {
        document.body.classList.add("isDragging");
      } else {
        document.body.classList.remove("isDragging");
      }
    },
  },
  methods: {
    showHideArrows: function() {
      const windowWidth = window.innerWidth;
      if (window.matchMedia("(hover: none) and (pointer: coarse)").matches) {
        this.$refs.arrowForward.style.display = "none";
        this.$refs.arrowBack.style.display = "none";
        console.log("match!");
        return;
      } else {
        console.log("no match!");
      }
      const el = this.$refs.listContainer;
      if(el) {
        const [translateX] = getComputedTranslateXY(el);
        const lastImage = this.$el.querySelector(".list > div:last-child");
        if (lastImage) {
          const { right } = lastImage.getBoundingClientRect();
          if (right > windowWidth) {
            this.$refs.arrowForward.style.display = "block";
          } else {
            this.$refs.arrowForward.style.display = "none";
          }
          if (translateX < 0) {
            this.$refs.arrowBack.style.display = "block";
          } else {
            this.$refs.arrowBack.style.display = "none";
          }
        }
      }
    },
    moveBackward: function() {
      const el = this.$refs.listContainer;
      const [translateX] = getComputedTranslateXY(el);
      if (translateX < 0) {
        el.style.transform = `translateX(${translateX + 100}px)`;
      }
      this.showHideArrows();
    },
    moveForward: function() {
      const el = this.$refs.listContainer;
      const [translateX] = getComputedTranslateXY(el);
      const lastImage = this.$el.querySelector(".list > div:last-child");
      const { right } = lastImage.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      if (right >= windowWidth) {
        el.style.transform = `translateX(${translateX - 100}px)`;
      }
      this.showHideArrows();
    },
    touchstart: function(e) {
      this.startX = e.touches[0].clientX - this.deltaX;
      this.startY = e.touches[0].clientY - this.deltaY;
      this.isDragging = false;
    },
    touchmove: function(e) {
      this.deltaX = e.touches[0].clientX - this.startX;
      this.deltaY = e.touches[0].clientY - this.startY;
      if (this.deltaX > 0) {
        this.deltaX = 0;
      }
      if (this.deltaX < -1 * this.maxDeltaX) {
        this.deltaX = -1 * this.maxDeltaX;
      }
      if (this.deltaY < -40) {
        this.isDragging = true;
      } else {
        this.isDragging = false;
        if (this.$el.querySelector(".list")) {
          const imagesSize = 90 + 16;
          const width = 16 + imagesSize * this.images.length;
          const wWidth = window.innerWidth;
          const diff = width - wWidth;
          if (diff > 0 && this.deltaX <= this.maxDeltaX) {
            this.$refs.listContainer.style.transform = `translateX(${this.deltaX}px)`;
          } else {
            this.$refs.listContainer.style.transform = `translateX(0px)`;
          }
        }
      }
    },
    touchend: function() {
      this.deltaY = 0;
      this.isDragging = false;
      if (this.$el.querySelector(".list")) {
        if (
          this.$el.querySelector(".list").getBoundingClientRect().width <
          window.innerWidth
        ) {
          this.$refs.listContainer.style.transform = `translateX(0px)`;
        }
      }
    },
    touchcancel: function() {
      this.isDragging = false;
    },
    nextLevel: function() {
      this.$root.$emit("level:next");
      this.startX = 0;
      this.startY = 0;
      this.deltaX = 0;
      this.deltaY = 0;
      delete this.maxDeltaX;
      this.completed = false;
      this.centered = false;
    },
    handleDrop: function(infos, event) {
      if (infos.from !== "grid") {
        return;
      }
      this.$root.$emit("cell:changed", {
        row: infos.row,
        col: infos.col,
        img: undefined,
      });

      this.$root.$emit("did:drag", {
        data: infos,
      });

      // placing image at the right place in the images list
      const imageIndex = this.grid.images.findIndex((i) => i.url === infos.img);
      const image = this.grid.images[imageIndex];
      const xPos = event.clientX - this.deltaX;
      const newPos = Math.floor(xPos / 96);
      this.grid.images.splice(imageIndex, 1);
      this.grid.images.splice(newPos, 0, image);
    },
    dragstart: function() {
      this.$root.$emit("tooltip:hide");
    },
    dragend: function() {
      this.$root.$emit("cells:deselect_all");
    },

    onImageClick: function(image) {
      if (this.$parent.artworkVisible) {
        const currentId = image.id;
        const shownId = this.$parent.currentArtwork.id;
        if (currentId == shownId) {
          console.log("emit hide");
          this.$root.$emit("image:hide");
        } else {
          console.log("emit show");
          this.$root.$emit("image:show", image, true);
        }
      } else {
        console.log("emit show!");
        this.$root.$emit("image:show", image, true);
      }
    },
  },
  components: {
    Fix,
    Congrats,
  },
};
</script>

<style scoped>
.iconBack,
.iconForward {
  display: none;
  position: absolute;
  background: red;
  border-radius: 50%;
  margin: 0;
  height: 24px;
  box-sizing: content-box;
  padding: 1rem;
  top: 31px;
  fill: #1a73e8;
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.302),
    0 2px 6px 2px rgba(60, 64, 67, 0.149);
  background: white;
  cursor: pointer;
}

@media screen and (min-width: 1000px) {
  .iconBack,
  .iconForward {
    display: block;
  }
}

.iconBack {
  left: 10px;
}

.iconForward {
  right: 10px;
}

.list-or-desc {
  position: relative;
  align-items: center;
  min-height: 118px;
  background: white;
  width: 100vw;
  align-items: center;
  justify-content: flex-start;
  display: flex;
  margin: 0;
  font-size: 1rem;
  z-index: 2;
  box-sizing: border-box;
  box-shadow: black;
  -webkit-box-shadow: 0 3px 6px rgba(114, 104, 104, 0.16),
    0 -3px 6px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 -3px 6px rgba(0, 0, 0, 0.05);
  -ms-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 -3px 6px rgba(0, 0, 0, 0.05);
  -o-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 -3px 6px rgba(0, 0, 0, 0.05);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 -3px 6px rgba(0, 0, 0, 0.05);
  z-index: 100;
}

.list-or-desc.centered {
  justify-content: center;
}

.centered .list {
  width: 100vw;
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 1000px) {
  /* .list-or-desc {
    width: 100vw;
    bottom: 0;
  }

  .asset {
    width: 100px;
    height: 100px;
  } */
}

.image-container {
  display: flex;
  position: relative;
}

.drop-area > div {
  max-height: 118px;
}

.image-container svg {
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
}

.image-container img {
  margin-right: 1rem;
}

.image-container h4 {
  max-width: 90%;
  margin: 0;
}

.list {
  padding: 1rem 0;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  /* overflow: hidden; */
  position: relative;
}

.list > div {
  flex-shrink: 0;
}

.list > div:first-child {
  margin-left: 1rem;
}

@media screen and (max-width: 1000px) {
  /* .list {
    width: auto;
    padding: 0;
    margin-left:auto;
    margin-right:auto;
  }

  .list > div {
    padding: 1rem 0;
  } */
}

.list img {
  width: 90px;
  height: 90px;
  max-width: none;
  object-fit: cover;
}

.list img:last-child {
  margin-right: 100px;
}

.shadow {
  position: absolute;
  pointer-events: none;

  width: 130px;
  height: 130px;
  right: 0;
  bottom: 0;

  background: linear-gradient(
    90.39deg,
    rgba(250, 250, 250, 0.04) 0.37%,
    #fafafa 75.91%
  );
}

.disabled {
  opacity: 0.2;
  pointer-events: none;
  display: none;
}

.footer {
  margin-top: 1rem;
  display: flex;
  justify-content: space-evenly;
}

.congrats,
.fixGrid {
  width: 100vw;
  z-index: 2;
  height: 118px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}

.congrats #lottie {
  width: 126px;
  height: 126px;
  padding: 12px;
}

.congrats-title {
  margin-top: 0;
  padding-top: 1rem;
}
.congrats-sentence {
  margin-bottom: 0;
}

.dragged-image {
  opacity: 0.5;
}

.drop-area {
  display: flex;
}

@media screen and (max-width: 1000px) {
  /* .list {
    width: auto;
  }

  .congrats,
  .fixGrid {
    height: 128px;
  } */
}
</style>

<style>
.images-tooltip {
  background: #669df6;
  left: 50% !important;
  /* transform: translateX(-50%)!important; */
  border-radius: 100px;
  top: -10px !important;
  width: 300px;
  margin-left: -150px;
}

.images-tooltip .tooltip-inner {
  padding-left: 20px;
  left: 30px;
}

.images-tooltip .tooltip-inner::before {
  content: "💡";
  position: absolute;
  left: 12px;
}

.floating {
  transform: translateY(-100px);
}

.images-tooltip .tooltip-arrow {
  left: 36px !important;
  width: 10px;
  height: 16px;
  position: absolute;
  bottom: -26px;
  border: solid transparent;
  content: " ";
  border-top-color: #669df6;
  border-width: 16px;
  margin-left: -16px;
}

/* Mobile */
@media screen and (hover: none) {
  body > div:not(.tooltip):last-child {
    display: none !important;
  }

  body.isDragging > div:not(.tooltip):last-child {
    display: block !important;
  }
}
</style>
